import React, { memo } from "react";

import { PropTypes } from "prop-types";
import { useSelector } from "react-redux";

import { OpenGeneralCell } from "components/DeploymentSaleSummaries/ConsignmentCells";
import { SummaryReactTable } from "components/DeploymentSaleSummaries/SummaryTable";

import {
  getBusinesses,
  getConsignments,
  getConsignmentWarningsByDeploymentSaleId,
  getProperties,
  selectIsPostSaleBalancedByConsignmentIdLookup,
  selectIsBalancedBySaleLotIdLookup,
  selectSaleLotIdsByConsignmentIdLookup,
  selectSaleLotQuantityByConsignmentIdLookup,
} from "selectors";

import { ExceptionsCell } from "./CellButton";

const CONSIGNMENT_EXCEPTIONS_COLUMNS = [
  {
    Header: <div style={{ paddingLeft: 6 }}>Vendor Name</div>,
    accessor: "vendorName",
    style: { paddingLeft: 12 },
    Cell: OpenGeneralCell,
  },
  {
    Header: "PIC",
    accessor: "pic",
    Cell: OpenGeneralCell,
  },
  {
    Header: "NVD Number",
    accessor: "nvdNumber",
    Cell: OpenGeneralCell,
  },
  {
    Header: "NVD HC",
    accessor: "nvdCount",
    Cell: OpenGeneralCell,
  },
  {
    Header: "Actual/Received HC",
    accessor: "receivedCount",
    Cell: OpenGeneralCell,
  },
  {
    Header: "Sale Lots Total",
    accessor: "saleLotsCount",
  },
  {
    Header: "Consignment Balanced",
    accessor: "consignmentBalanced",
  },
  {
    Header: "Sale Lots Balanced",
    accessor: "saleLotsBalanced",
  },
  // {
  //   Header: "Compliance",
  //   accessor: "compliance",
  // },
  // {
  //   Header: "NLIS",
  //   accessor: "nlis",
  //   Cell: OpenNlisCell,
  // },
  {
    Header: "Warnings",
    accessor: "warnings",
    Cell: ExceptionsCell,
  },
];

function ConsignmentWarningsTableComponent(props) {
  const { deploymentSaleId } = props;
  const consignmentWarnings = useSelector(
    getConsignmentWarningsByDeploymentSaleId(deploymentSaleId),
  );
  const consignments = useSelector(getConsignments);
  const businesses = useSelector(getBusinesses);
  const properties = useSelector(getProperties);
  const saleLotQuantityByConsignmentId = useSelector(
    selectSaleLotQuantityByConsignmentIdLookup,
  );
  const isPostSaleBalancedByConsignmentId = useSelector(
    selectIsPostSaleBalancedByConsignmentIdLookup,
  );
  const saleLotIdsByConsignmentId = useSelector(
    selectSaleLotIdsByConsignmentIdLookup,
  );
  const isBalancedBySaleLotId = useSelector(selectIsBalancedBySaleLotIdLookup);

  const data = consignmentWarnings.map(({ consignmentId, warnings }) => {
    const consignment = consignments[consignmentId] || {};
    const saleLotIds = saleLotIdsByConsignmentId[consignmentId] || [];
    const areSaleLotsBalanced = saleLotIds.every(
      saleLotId => isBalancedBySaleLotId[saleLotId],
    );

    return {
      consignmentId,
      warnings,
      pic: properties[consignment.vendor_property_id]?.PIC,
      nvdNumber: consignment.NVD,
      nvdCount: consignment.quantity_NVD,
      receivedCount: consignment.quantity,
      saleLotsCount: saleLotQuantityByConsignmentId[consignmentId],
      consignmentBalanced: isPostSaleBalancedByConsignmentId[consignmentId]
        ? "Balanced"
        : "Unbalanced",
      saleLotsBalanced: areSaleLotsBalanced ? "Balanced" : "Unbalanced",
      // compliance: ,
      // nlis: ,
      vendorName: businesses[consignment.vendor_id]?.name,
    };
  });

  return (
    <SummaryReactTable data={data} columns={CONSIGNMENT_EXCEPTIONS_COLUMNS} />
  );
}

ConsignmentWarningsTableComponent.propTypes = {
  deploymentSaleId: PropTypes.number.isRequired,
};

export default memo(ConsignmentWarningsTableComponent);
